// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aQGB_","largestCol":"styles_largestCol__1K7Tc","smallestCol":"styles_smallestCol__28-8i"};